// @ts-nocheck
import { useState } from "react";
import ManageTrigger from "@/components/trigger/manage-trigger";
import Breadcrumbs from "@/components/breadcrumbs";
import Router from "next/router";
import SettingsMenu from "@/components/settings/menu";
import Helper from '@/utils/helper';
import { createFileRoute } from '@tanstack/react-router'



const CreateTriggerPage = (props: any) => {

    let currPath = '';
    if (Router.router) {
        currPath = Router.router.asPath;
    }

    const [trigger, setTrigger] = useState<any>(null);

    const onSave = async (triggerId: any) => {
        if (triggerId) {
          Helper.nextRouter(Router.push, '/settings/trigger/list');
        }
    };

    return (
        <div className="settings-container">
            {/*<div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                            { text: 'Settings', link: '', suppressLink: true },
                            { text: 'Triggers', link: '/settings/trigger/list' },
                            { text: "Create", link: '' },
                        ]}
                    />
                </div>
                <div className="button-container">

                </div>
            </div>*/}
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <div className="settings-card">
                    <ManageTrigger
                        triggerToEdit={null}
                        module={trigger ? trigger.Module : null}
                        onSave={onSave}
                        defaultTriggerName={trigger ? trigger.Name : ""}
                        defaultSetting1={trigger ? trigger.TriggerConditions[0].Setting1 : null}
                        defaultSetting2={trigger ? trigger.TriggerConditions[0].Setting2 : null}
                        modal={false}
                        defaultRuleName={null}
                    />
                </div>
            </div>

            <style jsx>{`
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        .type-switch {
          position: absolute;
          top: 1.5rem;
          left: 580px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
        </div>
    );

};

export default CreateTriggerPage;

export const Route = createFileRoute('/_authenticated/settings/trigger/create')({ component: CreateTriggerPage })
